// Translations for the website
export const translations = {
  fr: {
    // Navigation
    nav: {
      blog: "Blog",
      portfolio: "Portfolio",
      projects: "Projets",
      about: "À propos",
      contact: "Contact",
      login: "Connexion",
      logout: "Déconnexion",
      adminDashboard: "Dashboard Admin",
    },
    // Hero Section
    hero: {
      role: "Ingénieur Logiciel Senior & Consultant",
      degree: "Master en Développement Logiciel et Systèmes d'Informations",
      bio: "Passionné par la création de solutions technologiques innovantes, je transforme les idées complexes en applications élégantes et performantes.",
      contactBtn: "Me Contacter",
      downloadCV: "Télécharger CV",
    },
    // Skills
    skills: {
      title: "Compétences Techniques",
      subtitle: "Un ensemble de compétences diversifiées acquises à travers des années d'expérience et de projets variés.",
    },
    // Services
    services: {
      title: "Mes Services",
      subtitle: "Des solutions sur mesure pour répondre à vos besoins technologiques les plus exigeants.",
      webDev: "Développement Web & Mobile",
      webDevDesc: "Applications performantes, sécurisées et adaptées aux besoins métiers.",
      security: "Consultation en Cybersécurité",
      securityDesc: "Audit, prévention des failles et sécurisation des systèmes informatiques.",
      integration: "Intégrations & Déploiements",
      integrationDesc: "APIs, services tiers, cloud, CI/CD et mise en production fiable.",
      conception: "Conception de Projets",
      conceptionDesc: "Analyse, architecture logicielle, planification et accompagnement technique.",
      maintenance: "Maintenance & Optimisation",
      maintenanceDesc: "Amélioration des performances, correction de bugs et évolutivité.",
      database: "Gestion des Données",
      databaseDesc: "Conception et optimisation de bases de données SQL et NoSQL.",
    },
    // Projects
    projects: {
      title: "Mes Projets",
      subtitle: "Découvrez une sélection de mes réalisations les plus significatives.",
      viewAll: "Voir tous les projets",
      viewDemo: "Démo",
      viewCode: "Code",
      technologies: "Technologies",
      filterAll: "Tous",
      noResults: "Aucun projet trouvé",
      noTech: "Aucun projet avec cette technologie.",
      comingSoon: "Les projets seront bientôt disponibles.",
      projectOfMonth: "Projet du Mois",
    },
    // Testimonials
    testimonials: {
      title: "Témoignages",
      subtitle: "Ce que disent mes clients et collaborateurs.",
    },
    // Newsletter
    newsletter: {
      title: "Restez informé",
      subtitle: "Inscrivez-vous à la newsletter pour recevoir mes derniers articles et actualités.",
      placeholder: "Votre adresse email",
      subscribe: "S'inscrire",
      success: "Inscription réussie !",
    },
    // Blog
    blog: {
      title: "Blog",
      subtitle: "Découvrez mes articles sur le développement logiciel, la cybersécurité et les dernières tendances technologiques.",
      search: "Rechercher un article...",
      noResults: "Aucun article trouvé",
      readMore: "Lire la suite",
      backToBlog: "Retour au blog",
      share: "Partager:",
      featured: "En vedette",
      comments: "Commentaires",
      writeComment: "Écrivez votre commentaire...",
      publish: "Publier",
      loginToComment: "Connectez-vous pour commenter",
    },
    // Contact
    contact: {
      title: "Me Contacter",
      subtitle: "Vous avez un projet en tête ou une question ? N'hésitez pas à me contacter. Je vous répondrai dans les plus brefs délais.",
      name: "Nom complet",
      email: "Email",
      subject: "Sujet",
      message: "Message",
      send: "Envoyer le message",
      success: "Message envoyé !",
      successMsg: "Merci pour votre message. Je vous répondrai dans les plus brefs délais.",
      followMe: "Me Suivre",
      location: "Localisation",
    },
    // About
    about: {
      title: "À propos de",
      me: "Moi",
      intro: "Je suis",
      intro2: "ingénieur logiciel senior et consultant basé au",
      intro3: "Titulaire d'un Master en Développement Logiciel et Systèmes d'Informations, je suis passionné par la création de solutions technologiques innovantes.",
      expertise: "Mon expertise couvre le développement full-stack, la cybersécurité et l'architecture logicielle. Je m'efforce de transformer les idées complexes en applications élégantes, performantes et sécurisées.",
      values: "Mes Valeurs",
      valuesSubtitle: "Les principes qui guident mon travail au quotidien.",
      excellence: "Excellence Technique",
      excellenceDesc: "Code propre, testé et documenté pour des solutions durables.",
      securityValue: "Sécurité",
      securityValueDesc: "La sécurité au cœur de chaque développement.",
      performance: "Performance",
      performanceDesc: "Applications optimisées pour une expérience utilisateur fluide.",
      journey: "Mon Parcours",
      journeySubtitle: "Des années d'expérience au service de vos projets.",
      ready: "Prêt à collaborer ?",
      readySubtitle: "Que vous ayez un projet en tête ou simplement envie de discuter, je suis toujours ouvert aux nouvelles opportunités.",
      viewPortfolio: "Voir mon Portfolio",
    },
    // Auth
    auth: {
      login: "Connexion",
      loginSubtitle: "Connectez-vous pour interagir avec le contenu",
      register: "Créer un compte",
      registerSubtitle: "Rejoignez la communauté pour interagir",
      fullName: "Nom complet",
      email: "Email",
      password: "Mot de passe",
      confirmPassword: "Confirmer le mot de passe",
      noAccount: "Pas encore de compte ?",
      hasAccount: "Déjà un compte ?",
      createAccount: "Créer un compte",
      signIn: "Se connecter",
      verifyEmail: "Vérifiez votre email",
      verifyEmailSent: "Un email de vérification a été envoyé à :",
      resendEmail: "Renvoyer l'email",
    },
    // CTA
    cta: {
      projectInMind: "Un projet en tête ?",
      projectSubtitle: "Discutons de votre projet et voyons comment je peux vous aider à le concrétiser.",
      startProject: "Démarrer un Projet",
      readBlog: "Lire mon Blog",
    },
    // Footer
    footer: {
      rights: "Tous droits réservés.",
      madeWith: "Développé avec passion au Cameroun",
      navigation: "Navigation",
    },
    // Common
    common: {
      loading: "Chargement...",
      error: "Erreur",
      success: "Succès",
      cancel: "Annuler",
      save: "Enregistrer",
      delete: "Supprimer",
      edit: "Modifier",
      close: "Fermer",
    },
    // Team Application
    team: {
      joinTeam: "Intégrer l'équipe",
      submitted: "Candidature envoyée !",
      loginRequired: "Vous devez être connecté pour soumettre une candidature.",
      successMsg: "Votre candidature a été soumise avec succès ! L'administrateur examinera votre demande.",
      fullName: "Nom complet",
      fullNamePlaceholder: "Votre nom complet",
      degree: "Dernier diplôme",
      degreePlaceholder: "Ex: Master en Informatique",
      fieldOfStudy: "Domaine d'étude",
      fieldPlaceholder: "Ex: Génie Logiciel",
      skills: "Compétences",
      skillsPlaceholder: "Ex: React, Python...",
      skillsHint: "Appuyez sur Entrée ou cliquez sur + pour ajouter",
      submit: "Valider ma candidature",
    },
    // Settings
    settings: {
      title: "Paramètres",
      subtitle: "Gérez votre compte et vos préférences",
      personalInfo: "Informations personnelles",
      personalInfoDesc: "Modifiez vos informations de profil",
      fullName: "Nom complet",
      email: "Adresse email",
      saveChanges: "Enregistrer",
      profileUpdated: "Profil mis à jour avec succès",
      changePassword: "Changer le mot de passe",
      changePasswordDesc: "Mettez à jour votre mot de passe",
      currentPassword: "Mot de passe actuel",
      newPassword: "Nouveau mot de passe",
      confirmPassword: "Confirmer le mot de passe",
      updatePassword: "Mettre à jour",
      passwordChanged: "Mot de passe modifié avec succès",
      passwordMismatch: "Les mots de passe ne correspondent pas",
      passwordTooShort: "Le mot de passe doit contenir au moins 6 caractères",
      dangerZone: "Zone de danger",
      dangerZoneDesc: "Actions irréversibles sur votre compte",
      deleteAccount: "Supprimer mon compte",
      confirmDelete: "Supprimer votre compte ?",
      confirmDeleteDesc: "Cette action est irréversible. Toutes vos données seront définitivement supprimées.",
      accountDeleted: "Compte supprimé avec succès",
    },
    // Notifications
    notifications: {
      title: "Notifications",
      noNotifications: "Aucune notification",
      newComment: "Nouveau commentaire",
      newApplication: "Nouvelle candidature",
      newContact: "Nouveau message",
      markAllRead: "Tout marquer comme lu",
    },
  },
  en: {
    // Navigation
    nav: {
      blog: "Blog",
      portfolio: "Portfolio",
      projects: "Projects",
      about: "About",
      contact: "Contact",
      login: "Login",
      logout: "Logout",
      adminDashboard: "Admin Dashboard",
    },
    // Hero Section
    hero: {
      role: "Senior Software Engineer & Consultant",
      degree: "Master's in Software Development and Information Systems",
      bio: "Passionate about creating innovative technological solutions, I transform complex ideas into elegant and high-performance applications.",
      contactBtn: "Contact Me",
      downloadCV: "Download CV",
    },
    // Skills
    skills: {
      title: "Technical Skills",
      subtitle: "A diverse set of skills acquired through years of experience and various projects.",
    },
    // Services
    services: {
      title: "My Services",
      subtitle: "Tailored solutions to meet your most demanding technological needs.",
      webDev: "Web & Mobile Development",
      webDevDesc: "High-performance, secure applications tailored to business needs.",
      security: "Cybersecurity Consulting",
      securityDesc: "Auditing, vulnerability prevention, and system security.",
      integration: "Integrations & Deployments",
      integrationDesc: "APIs, third-party services, cloud, CI/CD, and reliable production deployment.",
      conception: "Project Design",
      conceptionDesc: "Analysis, software architecture, planning, and technical support.",
      maintenance: "Maintenance & Optimization",
      maintenanceDesc: "Performance improvement, bug fixes, and scalability.",
      database: "Data Management",
      databaseDesc: "Design and optimization of SQL and NoSQL databases.",
    },
    // Projects
    projects: {
      title: "My Projects",
      subtitle: "Discover a selection of my most significant achievements.",
      viewAll: "View all projects",
      viewDemo: "Demo",
      viewCode: "Code",
      technologies: "Technologies",
      filterAll: "All",
      noResults: "No projects found",
      noTech: "No projects with this technology.",
      comingSoon: "Projects coming soon.",
      projectOfMonth: "Project of the Month",
    },
    // Testimonials
    testimonials: {
      title: "Testimonials",
      subtitle: "What my clients and collaborators say.",
    },
    // Newsletter
    newsletter: {
      title: "Stay Informed",
      subtitle: "Subscribe to the newsletter to receive my latest articles and news.",
      placeholder: "Your email address",
      subscribe: "Subscribe",
      success: "Successfully subscribed!",
    },
    // Blog
    blog: {
      title: "Blog",
      subtitle: "Discover my articles on software development, cybersecurity, and the latest tech trends.",
      search: "Search for an article...",
      noResults: "No articles found",
      readMore: "Read more",
      backToBlog: "Back to blog",
      share: "Share:",
      comments: "Comments",
      writeComment: "Write your comment...",
      publish: "Publish",
      loginToComment: "Login to comment",
      featured: "Featured",
    },
    // Contact
    contact: {
      title: "Contact Me",
      subtitle: "Have a project in mind or a question? Don't hesitate to contact me. I'll get back to you as soon as possible.",
      name: "Full name",
      email: "Email",
      subject: "Subject",
      message: "Message",
      send: "Send message",
      success: "Message sent!",
      successMsg: "Thank you for your message. I'll get back to you shortly.",
      followMe: "Follow Me",
      location: "Location",
    },
    // About
    about: {
      title: "About",
      me: "Me",
      intro: "I am",
      intro2: "a senior software engineer and consultant based in",
      intro3: "Holder of a Master's degree in Software Development and Information Systems, I am passionate about creating innovative technological solutions.",
      expertise: "My expertise covers full-stack development, cybersecurity, and software architecture. I strive to transform complex ideas into elegant, high-performance, and secure applications.",
      values: "My Values",
      valuesSubtitle: "The principles that guide my daily work.",
      excellence: "Technical Excellence",
      excellenceDesc: "Clean, tested, and documented code for sustainable solutions.",
      securityValue: "Security",
      securityValueDesc: "Security at the heart of every development.",
      performance: "Performance",
      performanceDesc: "Optimized applications for a smooth user experience.",
      journey: "My Journey",
      journeySubtitle: "Years of experience at your service.",
      ready: "Ready to collaborate?",
      readySubtitle: "Whether you have a project in mind or just want to chat, I'm always open to new opportunities.",
      viewPortfolio: "View my Portfolio",
    },
    // Auth
    auth: {
      login: "Login",
      loginSubtitle: "Sign in to interact with content",
      register: "Create Account",
      registerSubtitle: "Join the community to interact",
      fullName: "Full name",
      email: "Email",
      password: "Password",
      confirmPassword: "Confirm password",
      noAccount: "Don't have an account?",
      hasAccount: "Already have an account?",
      createAccount: "Create account",
      signIn: "Sign in",
      verifyEmail: "Verify your email",
      verifyEmailSent: "A verification email has been sent to:",
      resendEmail: "Resend email",
    },
    // CTA
    cta: {
      projectInMind: "Have a project in mind?",
      projectSubtitle: "Let's discuss your project and see how I can help you bring it to life.",
      startProject: "Start a Project",
      readBlog: "Read my Blog",
    },
    // Footer
    footer: {
      rights: "All rights reserved.",
      madeWith: "Made with passion in Cameroon",
      navigation: "Navigation",
    },
    // Common
    common: {
      loading: "Loading...",
      error: "Error",
      success: "Success",
      cancel: "Cancel",
      save: "Save",
      delete: "Delete",
      edit: "Edit",
      view: "View",
      close: "Close",
    },
    // Team Application
    team: {
      joinTeam: "Join the Team",
      submitted: "Application Submitted!",
      loginRequired: "You must be logged in to submit an application.",
      successMsg: "Your application has been submitted successfully! The administrator will review your request.",
      fullName: "Full name",
      fullNamePlaceholder: "Your full name",
      degree: "Last degree",
      degreePlaceholder: "Ex: Master in Computer Science",
      fieldOfStudy: "Field of study",
      fieldPlaceholder: "Ex: Software Engineering",
      skills: "Skills",
      skillsPlaceholder: "Ex: React, Python...",
      skillsHint: "Press Enter or click + to add",
      submit: "Submit my application",
    },
    // Settings
    settings: {
      title: "Settings",
      subtitle: "Manage your account and preferences",
      personalInfo: "Personal Information",
      personalInfoDesc: "Edit your profile information",
      fullName: "Full name",
      email: "Email address",
      saveChanges: "Save",
      profileUpdated: "Profile updated successfully",
      changePassword: "Change Password",
      changePasswordDesc: "Update your password",
      currentPassword: "Current password",
      newPassword: "New password",
      confirmPassword: "Confirm password",
      updatePassword: "Update",
      passwordChanged: "Password changed successfully",
      passwordMismatch: "Passwords do not match",
      passwordTooShort: "Password must be at least 6 characters",
      dangerZone: "Danger Zone",
      dangerZoneDesc: "Irreversible actions on your account",
      deleteAccount: "Delete my account",
      confirmDelete: "Delete your account?",
      confirmDeleteDesc: "This action is irreversible. All your data will be permanently deleted.",
      accountDeleted: "Account deleted successfully",
    },
    // Notifications
    notifications: {
      title: "Notifications",
      noNotifications: "No notifications",
      newComment: "New comment",
      newApplication: "New application",
      newContact: "New message",
      markAllRead: "Mark all as read",
    },
  },
};

export const getTranslation = (lang, key) => {
  const keys = key.split(".");
  let result = translations[lang];
  for (const k of keys) {
    result = result?.[k];
  }
  return result || key;
};
